<template>
  <v-container class="base-page-layout pb-4" fluid>
    <v-container class="pa-0 mb-3 page-actions" fill-height fluid>
      <v-layout align-center>
        <breadcrumbs v-if="$vuetify.breakpoint.smAndUp && !hideBreadcrumbs" class="breadcrumbs" />
        <v-spacer />
      </v-layout>
      <v-row>
        <v-btn v-if="showBackButton" class="ma-0 ml-3 unset-capitalize" color="marca-0-l40" text @click="goBack">
          <mf-icon class="pr-2" color="marca-0-l40" small>arrow_back</mf-icon>
          <span>Voltar</span>
        </v-btn>
      </v-row>
    </v-container>
    <v-layout>
      <p v-if="title && title.length" class="mb-4 page-title">{{ title }}</p>

      <v-tooltip bottom class="text-left help-icon">
        <template v-slot:activator="{ on }">
          <span v-if="$slots['title-tooltip']" v-on="on">
            <mf-icon class="mb-1 ml-1" color="cinza-0" small>info</mf-icon>
          </span>
        </template>
        <slot name="title-tooltip"></slot>
      </v-tooltip>

      <v-spacer />
      <slot name="card-extra"></slot>
    </v-layout>
    <slot></slot>
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  components: {
    Breadcrumbs,
  },
  props: {
    title: {
      type: String,
    },
    backRouter: {
      type: String,
      default: '',
    },
    hideBreadcrumbs: {
      type: Boolean,
    },
    showBackButton: {
      type: Boolean,
    },
  },
  data: () => ({
    tab: 0,
  }),
  methods: {
    goBack() {
      if (!this.backRouter.length) {
        this.$router.go(-1)

        return
      }

      this.$router.push(this.backRouter)
    },
  },
}
</script>
<style lang="scss">
.base-page-layout {
  .alerta {
    font-weight: bold;
    position: absolute;
    top: 0;
    margin: 0;
    left: 0;
    width: 100%;
    padding: 8px;
    border-radius: 0px;
    a {
      color: $branco;
    }
  }
  .unset-capitalize {
    text-transform: unset !important;
    letter-spacing: $letterspacing-1;
  }
}
@media print {
  .page-actions {
    display: none !important;
  }
}
@media print {
  .page-actions {
    display: none !important;
  }
}
</style>
